const instances = [];
const registry = [];

export const broadcast = (method,...args) => {
    instances.forEach(instance => {
        if(typeof instance[method] === 'function') {
            instance[method](...args);
        }
    });
}

export const register = Type=>{
    if(registry.indexOf(Type) !== -1) throw new Error(`tried to register Component ${Type} twice`);
    registry.push(Type);
    return Type;
}

export const init = (root = document.body)=>{
    registry.forEach(Type => {
        Type.init(root);
    });

    broadcast('mount');
}

export const resolveComponent = (el) => {
    for(let component of instances){
        if(component.el === el) return component;
    }
}

export class PureComponent {
    static selector = null

    static init = function(root = document.body){
        const Type = this;
        Type.broadcast('destroy');
        let targets = [root];
        if(Type.selector) {
            let selector = Type.selector;
            if(Array.isArray(selector)){
                selector = selector.join(',');
            }

            targets = Array.from(root.querySelectorAll(selector));
        }
        return targets.map(element=>{
            const comp = new Type(element);
            comp.create && comp.create();
            return comp;
        });
    }

    static broadcast = function(method, ...args){
        const Type = this;

        instances
        .filter(instance=>instance.constructor === Type)
        .forEach(instance => {
            if(typeof instance[method] === 'function') {
                instance[method](...args);
            }
        });
    }

    constructor(el){
        instances.push(this);
        this.el = el;
        this._staticClassName = el.className+'';
    }

    destroy() {
        this.el = null;
        const index = instances.indexOf(this);
        if(index > -1) {
            instances.splice(index,1);
        }
        this._listeners.forEach((listener)=>{
            this.off(...listener);
        });
    }

    _listeners = []

    on(target,evtName,callback,options) {
        if(arguments.length < 4 && typeof(target) === 'string') {
            ([target,evtName,callback,options] = [this.el,...arguments]);
        }

        target.addEventListener(evtName,callback,options);

        this._listeners.push(
            [target,evtName,callback,options]
        );

        return this;
    }

    off(target,evtName,callback) {
        if(arguments.length < 3 && typeof(target) === 'string') {
            ([target,evtName,callback] = [this.el,...arguments]);
        }

        target.removeEventListener(evtName,callback);

        return this;
    }

    get props(){
        const props = {};
        Object.keys(this.el.dataset).forEach((key)=>props[key] = this.el.dataset[key]);
        return props;
    }
}

export default class Component extends PureComponent {
    static init = function(root = document.body){
        return PureComponent.init.call(this,root).map(component => {
            component.render && component.render();
            return component;
        });
    }

    constructor(el){
        super(el);
        this.state = {};
    }

    shouldComponentUpdate(stateMutation){
        const {state} = this;
        for(let key in stateMutation) {
            if(!stateMutation.hasOwnProperty(key)) continue;
            if(!state.hasOwnProperty(key) || state[key] !== stateMutation[key]) return true;
        }
        return false;
    }

    async setState(stateMutation,callback) {
        const doRender = this.shouldComponentUpdate(stateMutation);
        this.state = {...this.state,...stateMutation};

        doRender && this.render && (await this.render());
        callback && callback();

        return this;
    }
}